import { appendImageCacheBust } from './appendImageCacheBust';
import { OfficeProfileRo } from '@/types';

const STORAGE_KEY = 'office-profile-image-version';

export const bumpOfficeProfileImageVersion = (): number => {
  const version = Date.now();
  sessionStorage.setItem(STORAGE_KEY, String(version));
  return version;
};

const getOfficeProfileImageVersion = (): number | null => {
  const value = sessionStorage.getItem(STORAGE_KEY);
  if (!value) return null;

  const parsed = Number(value);
  return Number.isFinite(parsed) ? parsed : null;
};

const withImageCacheBust = (url?: string | null): string | undefined => {
  if (!url || url.startsWith('data:') || url.startsWith('blob:')) return url ?? undefined;

  const version = getOfficeProfileImageVersion();
  if (!version) return url;

  return appendImageCacheBust(url, version);
};

export const withOfficeProfileImageCacheBust = (profile: OfficeProfileRo): OfficeProfileRo => ({
  ...profile,
  smallLogo: profile.smallLogo ? withImageCacheBust(profile.smallLogo) : profile.smallLogo,
  bigLogo: profile.bigLogo ? withImageCacheBust(profile.bigLogo) : profile.bigLogo,
});
